// extracted by mini-css-extract-plugin
export var isPrintedCell = "_xl-1";
export var printerIcon = "_xl-0";